module.exports = __webpack_public_path__ + "static/media/west_channel.6497fdad.png";